import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestUserService } from 'src/app/service/rest/user/rest-user.service';
import { RestUtilsService } from 'src/app/service/rest/utils/rest-utils.service';
import { environment } from 'src/environments/environment';
import { BackofficeRoles } from '../roles.model';
import { UpsSasToken } from '../utils.model';
import {
  EliotUser,
  UpsUser,
  UserConsent,
  UserConsentStatus,
} from './user.model';

@Injectable()
export class UserService {
  private _eliotUserLoaded: boolean = false;
  private _upsUserLoaded: boolean = false;
  private _eliotUser: EliotUser = new EliotUser();
  private _upsUser: UpsUser;
  private _touDocs: UserConsentStatus[] = [];
  private _sasToken: string;
  private _dateFormat: string;
  private _backendVersion: string;

  constructor(
    private restUser: RestUserService,
    private restUtils: RestUtilsService
  ) {
    const dataUpsUser = sessionStorage.getItem(environment.storage.upsUser);
    const dataEliotUser = sessionStorage.getItem(environment.storage.eliotUser);
    this.dateFormat = localStorage.getItem(
      environment.storage.settingsDateFormat
    );

    if (dataUpsUser != null) this.upsUser = JSON.parse(dataUpsUser);
    if (dataUpsUser == null)
      this.upsUser = new UpsUser(
        1,
        'oid1',
        'upserviceweb@yopmail.com',
        0,
        0,
        10,
        10,
        'UPservice',
        'Web',
        'UPservice'
      );

    if (dataEliotUser != null) this.eliotUser = JSON.parse(dataEliotUser);
  }

  get eliotUser(): EliotUser {
    return this._eliotUser;
  }

  set eliotUser(eliotUser: EliotUser) {
    this._eliotUser = eliotUser;
    sessionStorage.setItem(
      environment.storage.eliotUser,
      JSON.stringify(eliotUser)
    );
  }

  get upsUser(): UpsUser {
    return this._upsUser;
  }

  set upsUser(upsUser: UpsUser) {
    this._upsUser = upsUser;
  }

  public get sasToken(): string | undefined {
    let data: string;
    if (this._sasToken) return this._sasToken;
    else data = sessionStorage.getItem(environment.storage.sasToken);
    if (data != null) return data;
    else return undefined;
  }

  public set sasToken(value: string | undefined) {
    if (value) {
      sessionStorage.setItem(environment.storage.sasToken, value);
      this._sasToken = value;
    }
  }

  public get backendVersion(): string {
    return this._backendVersion;
  }
  public set backendVersion(value: string) {
    this._backendVersion = value;
  }

  get touLink() {
    return this._touDocs.find((doc) => doc.document == 'TermsOfUse').url;
  }

  get privacyLink() {
    return this._touDocs.find((doc) => doc.document == 'PrivacyPolicy').url;
  }

  public get touDocs(): UserConsentStatus[] {
    return this._touDocs;
  }
  public set touDocs(value: UserConsentStatus[]) {
    this._touDocs = value;
  }

  public get dateFormat(): string {
    return this._dateFormat;
  }
  public set dateFormat(value: string) {
    localStorage.setItem(environment.storage.settingsDateFormat, value);
    this._dateFormat = value;
  }

  loadUpsUser() {
    if (!this._upsUserLoaded) {
      console.log('LOAD UPS USER REST CALL');
      return this.restUser.getUser();
    }
    this._upsUserLoaded = true;
  }

  loadEliotUser() {
    if (!this._eliotUserLoaded) return this.restUser.getEliotUser();
  }

  loadUserConsent() {
    return this.restUser.getUserConsent();
  }

  public updateConditions(documentType: string) {
    /* let consent : UserConsent = new UserConsent();
    consent.marketingCampaigns = this.eliotUser.marketingCampaigns;
    consent.profiling = value; */
    return this.restUser.updateConditions(documentType);
  }

  public isBackofficeUser(): boolean {
    if (
      this.upsUser.backofficeRole == Number(BackofficeRoles.LEGRAND_ADMIN) ||
      this.upsUser.backofficeRole == Number(BackofficeRoles.LEGRAND_SERVICE)
    )
      return true;
    else return false;
  }

  public isPlantOwner(plantOwnerId: string): boolean {
    return this.upsUser.oid == plantOwnerId;
  }

  public updateUser(upsUser: UpsUser): Observable<UpsUser> {
    return this.restUser.updateUser(upsUser);
  }

  public getPromotionalVideo(): Observable<UpsUser> {
    return this.restUser.getPromotionalVideo();
  }

  public getBackendVersion() {
    this.restUser.getBackendVersion().subscribe((version: string) => {
      this.backendVersion = version;
    });
  }

  public getSasToken() {
    let queryString = '';

    if (this.isBackofficeUser())
      queryString = '?hasDocsResources=true&hasArFileResources=true';
    else queryString = '?hasDocsResources=true&hasArFileResources=false';

    this.restUtils.getSasToken(queryString).subscribe((result: UpsSasToken) => {
      this.sasToken = '?' + result.sas;
    });
  }

  getUserConsentStatus(): Observable<UserConsentStatus[]> {
    return this.restUser.getConsentStatus(this.eliotUser.language);
  }

  saveMaintenanceReminderDays(reminderDays: number) {
    this.restUser
      .saveMaintenanceReminderDays(reminderDays)
      .subscribe((result: UpsUser) => {
        this.upsUser = result;
      });
  }

  saveWarrantyReminderDays(reminderDays: number) {
    this.restUser
      .saveWarrantyReminderDays(reminderDays)
      .subscribe((result: UpsUser) => {
        this.upsUser = result;
      });
  }
}
